import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on path change, but preserves scroll on language switch
// (i.e., when only the /ar vs /en prefix changes).
function stripLang(pathname) {
  return pathname.replace(/^\/(ar|en)(?=\/|$)/, "") || "/";
}

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = sessionStorage.getItem("zv_last_path") || "";
    const prevStripped = stripLang(prev);
    const nowStripped = stripLang(pathname);

    if (prevStripped !== nowStripped) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    sessionStorage.setItem("zv_last_path", pathname);
  }, [pathname]);

  return null;
}
